var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWorkspaceMenuFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 14 10",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.938 9.714L.813 5.589 1.99 4.411l2.948 2.944-.002.001 7.071-7.07 1.179 1.178-7.071 7.072-1.178 1.177z",
    fill: "#005ce6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWorkspaceMenuFilled);
export default __webpack_public_path__ + "static/media/check_workspace_menu_filled.99975b13903f2b828068febed96f4a20.svg";
export { ForwardRef as ReactComponent };